import * as React from "react";
import classnames from "classnames";
import { INavigationBarData, INavigationItemsProps, LinkNames, navigationBarData } from "navigation/App";

import { handleToggleDropdown } from "shared/styles/helpers";
import { NavigationItemChevron } from "./NavigationItemChevron";
import { useLocation, useRouteMatch } from "react-router";
import DropdownButton from "shared/components/DropdownButton";
import { DropdownNavLink, NavLink, NavLinkContainer } from "navigation/styled";
import { removePageFromSearchParameters } from "processList/model/AppPath";

export const NavigationItems: React.FC<INavigationItemsProps> = (props) => {

    const location = useLocation();
    const isProcessSubProcessListMatch = useRouteMatch("/:base?/:processType(process|subprocess)/List/:environmentName/:agentGroupName");

    const generateHref = (link: INavigationBarData) => {
        // Pass search query params back and forth to Process/Subprocess list if one of the two are active
        if (isProcessSubProcessListMatch?.isExact
            && (link.activeLinkName === LinkNames.process || link.activeLinkName === LinkNames.subprocess
                && (props.activeLink === LinkNames.process || props.activeLink === LinkNames.subprocess))
        ) {
            const search = removePageFromSearchParameters(new URLSearchParams(location.search));
            return `${link.href}/${props.currentEnvironment}/${props.currentAgentGroup}${search}`;
        }
        
        if (link.subRoute) {
            return `${link.href}/${props.currentEnvironment}/${props.currentAgentGroup}/${link.subRoute}`;
        }

        return `${link.href}/${props.currentEnvironment}/${props.currentAgentGroup}`;
    };

    const getDropdownMenu = (link: INavigationBarData, linkIndex: number) => {
        const dropDownRefName = `${link.label}-dropdown`;

        const handleMenuToggle = () => {
            handleToggleDropdown(dropDownRefName);
        }

        const menuItems = link.children?.map(
            (childLink, childLinkIndex) => {
                if (props.hasRightsFor[childLink.permission]) {
                    const linkId = `nav_link_${linkIndex}_${childLinkIndex}`;
                    return <DropdownNavLink
                        key={linkId}
                        id={linkId}
                        title={childLink.label}
                        style={{ fontSize: "14px" }}
                        className={classnames({ active: (props.activeLink === childLink.activeLinkName) }, "actual-link-selector")}
                        href={generateHref(childLink)}
                    >
                        {childLink.label}
                    </DropdownNavLink>
                } else {
                    return null;
                }
            });

        return (
            <li
                id={"nav_link_" + linkIndex}
                key={"nav_link_" + linkIndex}
                title={link.label}
            >
                <DropdownButton
                    id={dropDownRefName}
                    buttonComponent={(
                        <NavLink
                            className={classnames('dropbtn', { active: (link.children?.some((x) => x.activeLinkName === props.activeLink) ?? false) }, `${link.label}-dropdown-button-selector`)}
                            onClick={handleMenuToggle}
                        >
                            {link.label}&nbsp;
                            <NavigationItemChevron />
                        </NavLink>
                    )}
                    dropDownButtonCustomStyles={{ position: 'initial' }}
                    dropDownContentCustomStyles={{ margin: "16px 0 0 -16px" }}
                >
                    {menuItems}
                </DropdownButton>
            </li >
        )
    };

    return (
        <NavLinkContainer id="menu" style={{ flexDirection: (props.asColumn ? 'column' : 'row') }}>
            {navigationBarData.map((link, linkIndex) => (
                props.hasRightsFor[link.permission] ? (
                    link.children != null
                        ? getDropdownMenu(link, linkIndex)
                        : (
                            <NavLink
                                href={generateHref(link)}
                                className={classnames({ active: (props.activeLink === link.activeLinkName) }, "actual-link-selector")}
                                key={link.label}
                            >
                                <li title={link.label}>
                                    {link.label}
                                </li>
                            </NavLink>
                        )
                ) : null
            ))}
        </NavLinkContainer>
    )
}
